/**
 * index.js
 * Written by: Alex Kasemir
 * Combines all of the actions contained in this directory
 */
import * as get from './getQuestion';
import * as getAll from './getQuestions';
import * as selectQuestion from './selectQuestion';
import * as submitQuestion from './submitQuestion';
import * as rateQuestion from './rateQuestion';
import * as setPlayedAnswer from './setPlayedAnswer';
import * as selectNextQuestion from './selectNextQuestion';
import * as savePlayedAnswer from './savePlayedAnswer';
import * as clearQuestionsMeta from './clearQuestionsMeta/clearQuestionsMeta';

export default {
  ...get,
  ...getAll,
  ...selectQuestion,
  ...submitQuestion,
  ...rateQuestion,
  ...setPlayedAnswer,
  ...selectNextQuestion,
  ...savePlayedAnswer,
  ...clearQuestionsMeta,
};
